import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { WelcomeTextInboxCallerDetail } from '@/models/welcomeTextInboxCaller';

export const fetchWelcomeTextInboxCallerDetails = async (callerId: string): Promise<WelcomeTextInboxCallerDetail> => {
  const response = await queryExecute({
    variables: {
      callerId,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query WelcomeTextInboxCallerDetails($callerId: String!) {
        welcomeTextInboxCallerDetails(callerId: $callerId) {
          messages {
            id
            direction
            message
            createdAt
          }
          callerPlan {
            softRegDate
            hardRegDate
            trialStartDate
            planName
            signupMethod
            groceryMaxCharge
          }
          rides {
            rideId
            timeInProgress
            timeCompleted
            pickupName
            dropoffName
          }
          callLogs {
            timeStart
            callFlow
            reason
            notes
          }
        }
      }
    `),
  });

  return response.data.welcomeTextInboxCallerDetails;
};
